/**
 * THIS FILE CONTAINS CODEGEN OUTPUT. DO NOT MODIFY MANUALLY
 *
 * Site ID
 * Identifier for a specific site on the platform.
 */
import * as t from 'io-ts';
export const schemaId = 'SiteID';
export const SiteId = t.brand(t.string, (x) => typeof x !== 'string' || x.match(RegExp('^cs[0-9a-fA-F]+$', 'u')) !== null, 'SiteId');
export default SiteId;
// Success
//# sourceMappingURL=SiteId.js.map